import { render, staticRenderFns } from "./refund-service-detail.vue?vue&type=template&id=6c504528&scoped=true"
import script from "./refund-service-detail.vue?vue&type=script&lang=js"
export * from "./refund-service-detail.vue?vue&type=script&lang=js"
import style0 from "./refund-service-detail.vue?vue&type=style&index=0&id=6c504528&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c504528",
  null
  
)

export default component.exports